import { ListUserPermissionsRequest } from 'api/admin/userPermissions/types'

const ROOT = 'userPermissions'

export const userPermissionsKeys = {
  all: [ROOT] as const,
  list: (params?: Omit<ListUserPermissionsRequest, 'cursor' | 'direction'>) =>
    [
      ROOT,
      'list',
      {
        userId: params?.userId,
        permission: params?.permission,
        pageSize: params?.pageSize,
      },
    ] as const,
  whoami: () => [ROOT, 'whoami'] as const,
  assignableUsers: (keyword?: string) =>
    [ROOT, 'assignableUsers', keyword] as const,
}
